import PropTypes from "prop-types";

import {
  questionContentCss,
  questionHeaderCss,
  titleAndIconContentCss,
  questionTitleCss,
  questionAnswerCounterCss,
  questionDescriptionCss,
} from "./PowerWordQuizResponseItem.styles";
import PowerWordStatusResponseIcons from "./PowerWordStatusResponseIcons";

const propTypes = {
  question: PropTypes.object,
};

const PowerWordQuizResponseItem = ({ question }) => {
  const counterRightAnswers = () =>
    question.isCorrect.filter((answerIsCorrect) => answerIsCorrect === true)
      .length ?? 0;

  return (
    <div css={questionContentCss}>
      <div css={questionHeaderCss}>
        <div css={titleAndIconContentCss}>
          <h4 css={questionTitleCss}>{question.headword}</h4>
          <PowerWordStatusResponseIcons answerStatus={question.isCorrect} />
        </div>
        <span css={questionAnswerCounterCss}>
          {counterRightAnswers()}/2 correct
        </span>
      </div>
      <div css={questionDescriptionCss}>{question.definition}</div>
    </div>
  );
};

PowerWordQuizResponseItem.propTypes = propTypes;
export default PowerWordQuizResponseItem;
